import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Search = {
  start: number;
  end: number;
  nama : string | number |null;
  kodemenu: string | null;
  tahun: string | null;
  nomor: string | null;
};

const initialState: Search = {
  start: 0,
  end: 10,
  kodemenu: null,
  tahun: null,
  nama: null,
  nomor: null,
};

export const paginatePutusanHukum= createSlice({
  name: 'paginatePutusanHukum',
  initialState,
  reducers: {
    replaceAllPaginate: (state, action: PayloadAction<Search>) => {
      // Use the action.payload to update the state
      state.start = action.payload.start;
      state.end = action.payload.end;
      state.kodemenu = action.payload.kodemenu;
      state.tahun = action.payload.tahun;
      state.nomor = action.payload.nomor;
      state.nama = action.payload.nama;
    },
  },
});

export const { replaceAllPaginate } = paginatePutusanHukum.actions;
export default paginatePutusanHukum.reducer;
